import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, PageEvent } from '@angular/material';
import { IDateRange, IPeriodDate } from 'src/app/action-history-queue/interfaces/date-range.interface';
import { DashboardReportsService } from '../../dashboard-reports.service';
import { IReceveidLeadAgentsPaginate } from '../../interfaces/received-lead-agents.interface';
import moment from 'moment';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-received-lead-by-agents',
  templateUrl: './received-lead-by-agents.component.html',
  styleUrls: ['./received-lead-by-agents.component.scss']
})
export class ReceivedLeadByAgentsComponent implements OnInit {  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @Input() startDate = moment().format('YYYY-MM-DD');
  @Input() endDate = moment().format('YYYY-MM-DD');
  @Input() events: Observable<any>;
  @Input() companyEvents: Observable<any>;
  dateRange: IDateRange;
  eventsSubscription: Subscription;
  displayedColumns: string[] = ['agentName', 'status', 'receivedLead', 'queueName', 'lastLogin'];
  dataSource = new MatTableDataSource([]);
  page = 1;
  maxResults = 5;
  order = 'DESC';
  total: number;
  loading: boolean;
  companyId: string = "";

  constructor(private service: DashboardReportsService) { }

  ngOnInit(): void {
    this.companyEvents.subscribe(res => {
      this.companyId = res;
      this.getData();
    });

    this.eventsSubscription = this.events.subscribe(
      (res: IPeriodDate) => {
        this.startDate = res.range.initialDate;
        this.endDate = res.range.endDate;
        this.getData();
      }
    );

    
  }

  getData(): void {
    this.loading = true;
    this.dateRange = { initialDate: this.startDate, endDate: this.endDate };
    this.companyId = this.companyId || "";
    this.service.getReceivedLeadAgents(this.page, this.maxResults, this.order, this.dateRange, this.companyId).subscribe(
      (res: IReceveidLeadAgentsPaginate) => {
        const {content, totalElements} = res;
        this.total = totalElements;
        this.dataSource = new MatTableDataSource(content);
        this.dataSource.sort = this.sort;
        this.loading = false;
      }, 
      err => {
        this.loading = false;
        console.log("Error at get received leads by agents: ", err);
      }
    );
  }

  pageChange(event: PageEvent): void {
    this.page = event.pageIndex + 1;
    this.maxResults = event.pageSize;
    this.getData();
  }

  sortTable(event: MatSort): void {
    if (!event.direction) {
      return;
    }

    this.order = event.direction.toUpperCase();
    this.getData();
  }

}
